import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
	adminDropDownMaster: {
		Languages: [],
		Profile_language_mapping: [],
		custom_tags: {},
		entity_type: {},
		geography: {},
		Roles: [],
	},
};

const adminCenterSlice = createSlice({
	name: "adminCenterSlice",
	initialState,
	reducers: {
		setAdminDropDownMaster: (state, action: PayloadAction<any>) => {
			state.adminDropDownMaster = action.payload;
		},
		setProfileLanguageMapping: (
			state,
			action: PayloadAction<{ profile_name: string; primary_language: any; secondary_language: any; display_profile_name: string; [key: string]: any }>
		) => {
			const { profile_name, primary_language, secondary_language, display_profile_name, ...props } = action.payload;
			const profile = state.adminDropDownMaster.Profile_language_mapping.find((profile) => profile.profile_name === profile_name);
			if (profile) {
				profile.primary_language = primary_language;
				profile.secondary_language = secondary_language;
				profile.isActive = true;
				profile.display_profile_name = display_profile_name;
			} else {
				state.adminDropDownMaster.Profile_language_mapping.push({
					...props,
					profile_name,
					primary_language,
					secondary_language,
					isActive: true,
					display_profile_name,
				});
			}
		},
	},
});

export const { setAdminDropDownMaster, setProfileLanguageMapping } = adminCenterSlice.actions;

export default adminCenterSlice.reducer;
